<template>
    <div class="i_nav">
        <a href="/"><img src="@/assets/images/logo.png" width="206" height="73" class="logo" /></a>
        <ul id="nav">
            <li v-for="(item, index) in menuItems" :key="index"
                @mouseover="handleMouseOver(index)"
                @mouseout="handleMouseOut(index)"
                :class="{ 'navs': isActiveIndex === index }" :style="getClassValue(index,menuItems.length)" >
                <a  :class="item.menuClass" @click="goto(item.href)" ></a>
                <ul  class="submenu">
                    <li v-for="(subItem, subIndex) in item.subItems" :key="subIndex">
                        <a :href="subItem.href" >{{ subItem.label }}</a>
                    </li>
                </ul>
            </li>
        </ul>
    </div>
</template>

<script>
    import commonFun from "@/util/common.js";
    export default {
        name: "MyMenu",
        props: {

        },
        data() {
            return {
                menuItems: [
                    {
                        label: '风险控制',
                        href:'Risk',
                        menuClass:'nav1',
                        subItems: [
                            { label: '渠道核查', href: '/Risk' },
                            { label: '合规核查', href: 'hgsj' },
                            { label: '供应商核查', href: '/gyssj' },
                            { label: '信息调查', href: '/xxdc' },
                        ],
                    },
                    {
                        label: '资讯管理',
                        href:'Advisory',
                        menuClass:'nav2',
                        subItems: [
                            { label: '管理咨询简介', href: '/Advisory' },
                            { label: '专家顾问团简介', href: '/zjgwtjj' },
                        ],
                    },
                    {
                        label: '资讯管理',
                        href:'Information',
                        menuClass:'nav3',
                        subItems: [
                            { label: '医生数据库查询管理平台', href: '/yssjk' },
                            { label: 'BI数据整合平台', href: '/bi' },
                            { label: '奖金计算平台', href: '/jjjspt' },
                            { label: 'IPAD数据采集平台', href: 'ipad' },

                        ],
                    },
                    {
                        label: '资讯管理',
                        href:'Outsourcing',
                        menuClass:'nav4',
                        subItems: [
                            { label: '新闻中心', href: 'Outsourcing' },
                        ],
                    },
                    {
                        label: '关于我们',
                        href:'about',
                        menuClass:'nav5',
                        subItems: [
                            { label: '关于我们', href: '/about' },
                            { label: '服务客户', href: '/hwkh' },
                            { label: '我们的愿景', href: '/wmdyj' },
                            { label: '我们的价值观', href: '/wmdjzg' },
                            { label: '联系方式', href: '/lxwm' },
                        ],
                    },
                ],
                isActiveIndex: null, // 用于跟踪当前激活的菜单项索引
            }
        },
        mounted() {
            this.$HTTP.getMenum().then(resp => {
                let data = resp.data;
                let arr = commonFun.getNewsCss();
                this.menuItems=[];
                if(data.length>0){
                    for(let i=0;i<data.length;i++){
                        let item = data[i];
                        if(item.code =='link'){
                            continue;
                        }
                        let itemPcode = item.code;
                        //设定样式
                        for(let j=0;j < arr.length; j++){
                            let jobj = arr[j];
                            if(item.href == jobj.value){
                                item.menuClass = jobj.menuClass;
                                break;
                            }
                        }
                        //匹配路由-新增的用id查询
                        let subItems = item.subItems;
                        if(subItems && subItems.length >0){
                            let childs=[];
                            for(let n=0;n < subItems.length; n++){
                                let subitemObj = subItems[n];
                                let myrouter= commonFun.getRouter(itemPcode,subitemObj.code,subitemObj.id);
                                subitemObj.href = '/'+ myrouter;
                                childs.push(subitemObj);
                            }
                            item.subItems = childs;
                        }
                        this.menuItems.push(item);
                    }
                }
            });
        },
        methods: {
            handleMouseOver(index) {
                this.isActiveIndex = index;
            },
            handleMouseOut(index) {
                if (this.isActiveIndex === index) {
                    this.isActiveIndex = null;
                }
            },
            goto(url){
                url = '/' + url;
                //console.log(url)
                this.$router.push(url);
            },
            getClassValue(index,size){
                let nv = Number(size -1);
                if(index < nv){
                    return '';
                }else{
                    return 'background:none;';
                }
            }
        },
        watch: {

        }
    }
</script>

<style lang="scss" scoped >
    .i_nav{width:961px; height:88px;background:url("../../assets/images/bg_nav_06.png") no-repeat left top;margin:0 auto;z-index:999;position:absolute;top:21px;left:21px; z-index:9999;}
    .logo{width:206px;height:73px;float:left;}
    #nav{width:645px;height:73px;padding-left:77px;float:left;}
    #nav li{width:129px;height:73px;float:left;background:url("../../assets/images/nav_fege.jpg") no-repeat right center;float:left;position:relative;}
    #nav li a{height:73px;}
    .nav1{width:127px;display:block;background:url("../../assets/images/nav1.png") no-repeat left top;}
    .nav2{width:127px;display:block;background:url("../../assets/images/nav2.jpg") no-repeat left top;}
    .nav3{width:127px;display:block;background:url("../../assets/images/nav3.jpg") no-repeat left top;}
    .nav4{width:127px;display:block;background:url("../../assets/images/nav4.jpg") no-repeat left top;}
    .nav5{width:127px;display:block;background:url("../../assets/images/nav5.jpg") no-repeat left top;}
    #nav li a:hover{width:129px;height:73px;float:left;background-position:left bottom;}
    #nav li.navs a{	background-position:left bottom;font-size:12px;}
    #nav li ul{width:184px;position:absolute;left:-9999px;top:73px;text-align:center;background:#f9fcfc url("../../assets/images/bg_xiala.jpg") repeat-x left bottom;border-left:1px solid #aed4d5;border-right:1px solid #aed4d5;border-bottom:1px solid #aed4d5;}
    #nav li.navs ul{position:absolute;left:0px;top:73px;width:184px;height:auto!important;min-height:73px;height:73px;text-align:center;padding-top:12px;padding-bottom:12px;}
    #nav li.navs ul li{ height:28px;width:180px;background:none;}
    #nav li.navs ul li a{display:block;width:149px;background:url("../../assets/images/dot_1.gif") no-repeat 21px center;height:28px;line-height:28px;color:#006765;text-align:left;clear:both;padding-left:31px;padding-bottom:0px;}
    #nav li.navs ul li a:hover{color:#ea5503;width:149px;background:url("../../assets/images/dot_1.gif") no-repeat 21px center;height:28px;line-height:28px;text-decoration:none;}

    #nav li.navs .t1{_width:150px;width:160px;}
    #nav li.navs .t1 li{height:28px;width:119px;background:none;}
    #nav li.navs .t1 li a{width:119px;}
    #nav li.navs .t1 li a:hover{width:119px;}


</style>
